import { render, staticRenderFns } from "./LmBreadcrumb.vue?vue&type=template&id=f87174fa&scoped=true&"
import script from "./LmBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./LmBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./LmBreadcrumb.vue?vue&type=style&index=0&id=f87174fa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87174fa",
  null
  
)

export default component.exports